/* CD site.css 的 nav 样式，搬过来用 CSS Modules */

.nav {
  height: var(--header-height);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  max-width: var(--container-max);
  margin: 0 auto;
  gap: 16px;
}
@media (min-width: 640px) {
  .nav { padding: 0 24px; }
}
@media (min-width: 1024px) {
  .nav { padding: 0 var(--container-px); }
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: var(--color-ink);
}

.brand img {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-pill);
  display: block;
}

.brandName {
  font-weight: 600;
  font-size: 18px;
  letter-spacing: -0.01em;
}

.links {
  display: none; /* mobile 隐藏胶囊 nav */
  align-items: center;
  gap: 4px;
  background: var(--color-chip);
  border-radius: var(--radius-pill);
  padding: 5px;
}
@media (min-width: 640px) {
  .links { display: flex; }
}

.linkItem {
  text-decoration: none;
  color: #2a2a2a;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: var(--radius-pill);
  transition: background 0.15s ease;
}

.linkItem:hover {
  background: #ebebeb;
  text-decoration: none;
}

.linkItem.active {
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(0, 0, 0, 0.04);
  color: var(--color-ink);
}

.cta {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: var(--color-ink);
  color: #fff;
  border-radius: var(--radius-pill);
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  transition: background 0.15s ease;
  white-space: nowrap;
}
@media (min-width: 640px) {
  .cta { padding: 10px 18px; font-size: 14px; gap: 8px; }
}

.cta:hover {
  background: #222;
  text-decoration: none;
}

.arrow {
  width: 16px;
  height: 16px;
}
